import React from 'react';
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import PropTypes from "prop-types";
import renderOptions from "../../../utils/richTextRendererOptions";
import idCreator from "../../../utils/idCreator";

const TermsSection = ({ header = '', text = {}, htmlId = '' }) => {
    return (
        <section>
            {header && <h3 id={htmlId || idCreator(header)}>{header}</h3>}
            {text && documentToReactComponents(text, renderOptions)}
        </section>
    );
};

TermsSection.propTypes = {
    header: PropTypes.string,
    text: PropTypes.object
}



export default TermsSection;
